import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

/* CSS load order matters — layers → tokens → reset → base styles */
import './styles/layers.css';
import '../ezhard-root/tokens/tokens.css';
import '@ezhard/ui/index.css';
import './styles/reset.css';
import './styles/global.css';
import './styles/animations.css';
import './styles/rtl.css';

import { App } from './app/App';

const root = document.getElementById('root');

if (!root) {
  throw new Error('Root element not found. Check index.html for <div id="root">.');
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
